export enum Ordering {
  Asc = "asc",
  Desc = "desc",
}

export const orderingOptions = Object.values(Ordering);
